import { FormattedMessage } from 'react-intl'
import { call, put, select, takeLatest } from 'redux-saga/effects'

import { IHateoasLink } from '@store'
import {
  downloadShortlistCsv,
  downloadShortlistCsvFailure,
} from '@store/agentSourcedCreators/actions'
import { selectDownloadShortlistCsvLink } from '@store/agentSourcedCreators/selectors'
import { selectAuthToken } from '@store/auth'
import { Toaster } from '@tribegroup'
import { downloadCSV } from '@utils'

// Only used if Platform ever responds without a Content-Disposition; the server
// owns the real filename (BRAND-9636).
const FALLBACK_FILENAME = 'shortlist.csv'

export function* downloadShortlistCsvSaga() {
  try {
    const token: string = yield select(selectAuthToken)
    const link: IHateoasLink | undefined = yield select(selectDownloadShortlistCsvLink)

    if (!link) {
      yield put(
        downloadShortlistCsvFailure('download_csv link not present on the shortlist collection'),
      )
      // BRAND-9636 C1: mirrors bulkRejectCreators.ts's failure mechanism (same
      // directory) — dispatch the failure action AND toast, so a click that
      // previously did nothing tells the user the download failed.
      yield call(Toaster.createToast, FormattedMessage, {
        id: 'creatorSearch.shortlist.download.toast.failure',
      })
      return
    }

    yield call(
      downloadCSV,
      link,
      FALLBACK_FILENAME,
      { Authorization: `Bearer ${token}` },
      {
        preferServerFilename: true,
      },
    )
  } catch (e: any) {
    yield put(downloadShortlistCsvFailure(e?.message ?? 'Failed to download the shortlist CSV'))
    // Same mechanism as above and as bulkRejectCreators.ts's catch branch.
    yield call(Toaster.createToast, FormattedMessage, {
      id: 'creatorSearch.shortlist.download.toast.failure',
    })
  }
}

export default function* watchDownloadShortlistCsv() {
  yield takeLatest(downloadShortlistCsv.type, downloadShortlistCsvSaga)
}
